import React, { Component } from "react"
import edsider1 from "../assets/images/edsider1.svg"
import edsider2 from "../assets/images/edsider2.svg"
import edsider3 from "../assets/images/edsider3.svg"

class ChooseEdsider extends Component {
  render() {
    return (
      <>
        <div id="edsider" className="container section-container">
          <div className="pt-5 pb-5 px-5">
            <h1 className="edsider-section-title">Why choose EdSider?</h1>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-md-4 ">
              <div className=" edsider-card">
                <div className="row d-flex justify-content-center edsider-img-container">
                  <img src={edsider1} alt="Image" />
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-title">
                    Expertly Designed <br /> Papers
                  </h3>
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-para">
                    Our team of experienced teachers ensures that our model
                    papers cover all essential skills required for the exams
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 ">
              <div className=" edsider-card">
                <div className="row d-flex justify-content-center edsider-img-container">
                  <img src={edsider2} alt="Image 2" />
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-title">
                    Immediate <br /> Test Scores
                  </h3>
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-para">
                    Our online MCQ system provides instant feedback, allowing
                    students to track their progress and identify areas for
                    improvement
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 ">
              <div className=" edsider-card">
                <div className="row d-flex justify-content-center edsider-img-container">
                  <img src={edsider3} alt="Image 2" />
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-title">
                    User Friendly <br /> Platform
                  </h3>
                </div>
                <div className="row d-flex justify-content-center text-center">
                  <h3 className="edsider-card-para">
                    Edsider offers a seamless and intuitive platform that is
                    easy for students, parents, and teachers to navigate{" "}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ChooseEdsider
